import { render } from "./CheckUpResult.vue?vue&type=template&id=cdeabebc"
import script from "./CheckUpResult.vue?vue&type=script&lang=js"
export * from "./CheckUpResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__